import { useMemo } from 'react';
import { calculateMapScale } from '~/_shared/utils/map/calculateMapScale';

export type MapBoundaryDistanceToPixelsMap = {[zoom: number]: {latSize: number; lngSize: number} | undefined};

export const useMapBoundaryDistanceToPixels = (map: google.maps.Map | undefined): MapBoundaryDistanceToPixelsMap | undefined => {

  return useMemo(() => {
    const projection = map?.getProjection();
    if (!projection) {
      return;
    }

    const baseZoomScale = calculateMapScale(0);

    const zeroPoint = { lat: 0, lng: 0 };
    const latPoint = { lat: 1, lng: 0 };
    const lngPoint = { lat: 0, lng: 1 };

    const zeroPointPixel = projection.fromLatLngToPoint(zeroPoint);
    const latPointPixel = projection.fromLatLngToPoint(latPoint);
    const lngPointPixel = projection.fromLatLngToPoint(lngPoint);

    if (!zeroPointPixel || !latPointPixel || !lngPointPixel) {
      return;
    }

    const latSize = Math.abs(zeroPointPixel.y - latPointPixel.y);
    const lngSize = Math.abs(zeroPointPixel.x - lngPointPixel.x);

    const result: MapBoundaryDistanceToPixelsMap = {};

    for (let zoomLevel = 0; zoomLevel <= 30; zoomLevel++) {
      const scale = calculateMapScale(zoomLevel);

      const latSizeForLevel = latSize / (scale / baseZoomScale);
      const lngSizeForLevel = lngSize / (scale / baseZoomScale);

      result[zoomLevel] = { latSize: latSizeForLevel, lngSize: lngSizeForLevel };
    }

    return result;
  }, [map]);
};
